// extracted by mini-css-extract-plugin
export default {"initials":"styles_initials__7f+df"};